import { DesmembramentoDto } from "./desmembramento-dto";
import { FracaoDto } from "./fracao-dto";
import { SistemaInteresseDto } from "./sistema-interesse-dto";

export class Composicao implements DesmembramentoDto {
  public sequencialDesmembramento: number;
  public periodoApuracao: Date;
  public dataVencimento: Date;
  public valorTotal: number;
  public sistemaInteresse: SistemaInteresseDto;
  public referencia: string;
  public processo: string;
  public unidadeFederativaSigla: string;
  public numeroInscricaoDAU: number;
  public numeroCib: string;
  public numeroCadastroNacionalObras: number;
  public numeroIdentificacaoTrabalhador: number;
  public cnpjPrestador: number;
  public cpfSegurado: number;
  public cnpjOrdemDebito: number;
  public cpfDebito: number;
  public fracoes: FracaoDto[];
  public procInfoComplementar: string;
  public situacao: string;

  public codigoPrincipal: string;
  public codigoMulta: string;
  public codigoJuros: string;
  public codigoEncargo: string;
  public valorPrincipal: string;
  public valorMulta: string;
  public valorJuros: string;
  public valorEncargo: string;

  public cnpjCpfDebito: number;

  constructor(desmembramento: DesmembramentoDto) {
    Object.assign(this, desmembramento);

    this.calcularCodigos();
    this.calcularCnpjPfDebito();
  }

  private calcularCodigos(): void {
    // 817657 RN - Pagamento - Dados do Pagamento
    // RN 1.3.2. - Formatação de Saída do Código de Receita
    const codigos = new Array(4).fill(null);
    const valores = new Array(4).fill(null);

    for (const fracao of this.fracoes) {
      let codigo: string = fracao.receita.receitaCodigo.toString().padStart(4, "0");

      if (fracao.receita.extensaoReceitaCodigo != null) {
        codigo += `-${fracao.receita.extensaoReceitaCodigo.toString().padStart(2, "0")}`;
      }

      const index = fracao.tipoFracao.codigo - 1;

      codigos[index] = codigo;
      valores[index] = fracao.valor;
    }

    [this.codigoPrincipal, this.codigoMulta, this.codigoJuros, this.codigoEncargo] = codigos;
    [this.valorPrincipal, this.valorMulta, this.valorJuros, this.valorEncargo] = valores;
  }

  private calcularCnpjPfDebito(): void {
    // 817657 RN - Pagamento - Dados do Pagamento
    // RN 1.3.1-22 - Recuperação do NI do Débito
    if (this.cpfDebito != null) {
      this.cnpjCpfDebito = this.cpfDebito;
      return;
    }
    
    if (this.cnpjOrdemDebito != null) {
      this.cnpjCpfDebito = this.cnpjOrdemDebito;
      return;
    }
  }
}